import React, { useState } from 'react';

import { MarketingTagsDropdown } from 'src/app/components/form-elements/dropdowns/marketing-tags-dropdown';
import { FormSection } from 'src/app/components/lib/form';
import { Modal } from 'src/app/components/lib/modal';
import { useEditCampaignTagsMutation } from 'src/app/queries/marketing/edit-campaign-tags';
import { useNotificationActions } from 'src/app/state/notifications';

type Campaign = {
  [key: string]: any;
  CampaignName: string;
  MarketingCampaignId: number;
};

type Props = {
  campaigns: Campaign[];
  onClose: () => void;
};

export function MarketingEditTags({ campaigns, onClose }: Props) {
  const notifications = useNotificationActions();

  const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);

  const { mutate: editCampaignTags, isLoading } = useEditCampaignTagsMutation();

  const handleSave = () => {
    try {
      const campaignIds = campaigns.map((campaign) => campaign.MarketingCampaignId);

      editCampaignTags(
        { MarketingCampaignIds: campaignIds, MarketingTagIds: selectedTagIds },
        {
          onSuccess: () => {
            notifications.success({ message: 'Successfully updated campaign tags.' });
            onClose();
          },
          onError: (error: any) => {
            notifications.error({
              message: 'Error updating campaign tags.',
              subContent: error?.message || 'Please try again later.',
            });
          },
        }
      );
    } catch (error) {
      notifications.error({ message: 'An unexpected error occurred' });
    }
  };

  return (
    <Modal
      Content={
        <FormSection>
          <MarketingTagsDropdown
            label='Tags:'
            placeholder='Select tags'
            value={selectedTagIds}
            onChange={(tagIds) => setSelectedTagIds(tagIds)}
          />
        </FormSection>
      }
      open
      primaryActions={[
        {
          label: 'Save',
          onClick: handleSave,
          disabled: isLoading,
        },
      ]}
      title='Edit tags'
      width='576px'
      onClose={onClose}
    />
  );
}
